import { memo, useMemo } from "react";

import { useProduct } from "@shopify/hydrogen-react";

import { formatProductVariant } from "@root/tablescape/utilities";
import { getLoyaltyTier } from "@tablescape/utilities/customer";

import { GiftWithPurchaseView } from "./GiftWithPurchase.view";

type Props = {
  giftWithPurchase: {
    ourGiftForYou: string;
  };
  linkReadLess?: string;
  linkReadMore?: string;
};

const GiftWithPurchaseBase = ({
  giftWithPurchase,
  linkReadLess,
  linkReadMore,
}: Props) => {
  const { selectedVariant } = useProduct();

  const selectedGiftWithPurchase = useMemo(
    () => formatProductVariant(selectedVariant).giftWithPurchase,
    [selectedVariant]
  );

  const loyaltyTier = useMemo(getLoyaltyTier, []);

  if (
    !selectedGiftWithPurchase ||
    (loyaltyTier &&
      selectedGiftWithPurchase.eligibleLoyaltyTiers?.includes(loyaltyTier))
  ) {
    return null;
  }

  return (
    <GiftWithPurchaseView
      bannerText={selectedGiftWithPurchase.bannerText}
      description={selectedGiftWithPurchase.description}
      linkReadLess={linkReadLess}
      linkReadMore={linkReadMore}
      ourGiftForYou={giftWithPurchase.ourGiftForYou}
      thumbnailUrl={selectedGiftWithPurchase.thumbnailUrl}
      title={selectedGiftWithPurchase.title}
    />
  );
};

export const GiftWithPurchase = memo(GiftWithPurchaseBase);
